(function() {
	// globals
	PM.Roles = {};
	PM.Roles.functions = [];

	// app functions

	PM.Roles.renderRoles = function() {
		$.when(
			$.get('/api/roles'),
			ejs.preloadTemplate('/app/config/roles/templates/roles.ejs'),
			ejs.preloadTemplate('/app/config/roles/templates/role-modal.ejs')
		).done(function(rolesResult) {
			var roles = rolesResult[0];
			var contentHtml = ejs.rr('/app/config/roles/templates/roles.ejs', { roles: roles });
			PM.Config.renderSection('roles', contentHtml);
		});
	};

	PM.Roles.showModal = function(role) {
		var isEdit = !!role;
		var modalTitle = isEdit ? i18next.t('Edit Role') : i18next.t('Create Role');

		$.when(
			$.get('/api/roles/functions'),
			ejs.preloadTemplate('/app/config/roles/templates/role-modal.ejs')
		).done(function(functionsResult) {
			var functions = functionsResult[0];

			var selectedFunctionIds = [];
			if (isEdit && role.functions) {
				selectedFunctionIds = role.functions.map(function(f) { return f.id; });
			}

			var modalHtml = ejs.rr('/app/config/roles/templates/role-modal.ejs', {
				modalTitle: modalTitle,
				role: role || {},
				functions: functions,
				selectedFunctionIds: selectedFunctionIds
			});

			var $modal = $(modalHtml);
			$('body').append($modal);
			var bsModal = new bootstrap.Modal($modal[0]);
			bsModal.show();

			$modal.on('hidden.bs.modal', function() {
				$modal.remove();
			});

			$modal.on('shown.bs.modal', function() {
				$modal.find('.js-role-name').focus();
			});
		});
	};

	// events

	// "Create Role" button
	$(document).on('click', '.js-role-add', function(e) {
		e.preventDefault();
		if (!PM.Shell.checkFeature('custom_roles')) {
			PM.Roles._showUpgradeToast();
			return;
		}
		PM.Roles.showModal(null);
	});

	// Edit button
	$(document).on('click', '.js-role-edit', function(e) {
		e.preventDefault();
		if (!PM.Shell.checkFeature('custom_roles')) {
			PM.Roles._showUpgradeToast();
			return;
		}
		var id = $(this).data('role-id');
		$.get('/api/roles').done(function(roles) {
			var role = roles.find(function(r) { return r.id === id; });
			if (role) {
				PM.Roles.showModal(role);
			}
		});
	});

	// Save button in modal
	$(document).on('click', '.js-role-save', function() {
		var $modal = $(this).closest('.js-role-modal');
		var id = $modal.find('.js-role-id').val();
		var name = $modal.find('.js-role-name').val().trim();
		var description = $modal.find('.js-role-description').val().trim();

		if (!name) {
			new Notify({ status: 'error', text: i18next.t('Name is required.'), timeout: 3000 });
			return;
		}

		var function_ids = [];
		$modal.find('.js-role-function:checked').each(function() {
			function_ids.push(parseInt($(this).val(), 10));
		});

		if (function_ids.length === 0) {
			new Notify({ status: 'error', text: i18next.t('At least one permission must be selected.'), timeout: 3000 });
			return;
		}

		var data = {
			name: name,
			description: description,
			function_ids: function_ids
		};

		var request;
		if (id) {
			request = $.ajax({
				url: '/api/roles/' + id,
				method: 'PUT',
				contentType: 'application/json',
				data: JSON.stringify(data)
			});
		} else {
			request = $.ajax({
				url: '/api/roles',
				method: 'POST',
				contentType: 'application/json',
				data: JSON.stringify(data)
			});
		}

		request.done(function() {
			bootstrap.Modal.getInstance($modal[0]).hide();
			PM.Roles.renderRoles();
			new Notify({ status: 'success', text: i18next.t('Role saved.'), timeout: 3000 });
		});
	});

	// Delete button
	$(document).on('click', '.js-role-delete', function(e) {
		e.preventDefault();
		if (!PM.Shell.checkFeature('custom_roles')) {
			PM.Roles._showUpgradeToast();
			return;
		}
		var id = $(this).data('role-id');
		var name = $(this).data('role-name');

		if (!confirm(i18next.t('Delete role') + ' "' + name + '"? ' + i18next.t('People assigned to this role will lose its permissions.'))) {
			return;
		}

		$.ajax({
			url: '/api/roles/' + id,
			method: 'DELETE'
		}).done(function() {
			PM.Roles.renderRoles();
			new Notify({ status: 'success', text: i18next.t('Role deleted.'), timeout: 3000 });
		});
	});

	// app startup

	page('/config/roles', PM.Shell.routeWithPermission('view_roles', PM.Roles.renderRoles));

	PM.Roles._showUpgradeToast = function() {
		new Notify({
			status: 'warning',
			text: i18next.t('This feature requires a higher plan.') + ' <a href="/pricing">' + i18next.t('Upgrade') + '</a>',
			timeout: 5000
		});
	};
})();
